import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Checkbox, Button, CircularProgress } from '@mui/material'
import { PaymentMethodComponent } from './components/PaymentMethodComponent'
import { CreditDebitComponent } from './components/CreditDebitComponent'
import { DuitnowComponent } from './components/DuitnowComponent'
import { TermsAndConditions } from '../../../components/termsandconditions/TermsAndConditions'
import LoadingModal from './components/LoadingModal'
import { ayeApi } from '../../../core'
import { useApp } from '../../../context/usePortal'
import useRegistration from '../../../hooks/useRegistration'
import logo from '../../../assets/logos/aye-logo.png'
import backgroundImage from '../../../assets/background.jpg'
import { GeneratePayUrlResponse } from '../../../core/api/http-methods/generate-pay-url'

const RegisterScreen = () => {
  const [open, setOpen] = useState<boolean>(false)
  const [countryPhoneCode, setCountryPhoneCode] = useState<string | undefined>()
  const [idNumber, setIdNumber] = useState<string | undefined>()
  const [phoneNumber, setPhoneNumber] = useState<string | undefined>()
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState<string>('')
  const [checked, setChecked] = useState<boolean>(false)
  const [errorMessage, setErrorMessage] = useState<string>()
  const { loading } = useRegistration()
  const [redirectLoading, setRedirectLoading] = useState(false)
  const [idType, setIdType] = useState<string>('')
  const navigate = useNavigate()
  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    setIdType(event.target.value as string)
  }
  const submit = async () => {
    const face_index = sessionStorage.getItem('face_index')
    const pin = sessionStorage.getItem('pin')
    if (
      !phoneNumber ||
      idTypeError() ||
      phoneNumberError() ||
      !face_index ||
      !pin
    ) {
      return setErrorMessage('Please fill all the required fields')
    }

    if (!checked) {
      return setErrorMessage('Please accept terms and conditions.')
    }

    setErrorMessage(undefined)
    setRedirectLoading(true)

    let alreadyRegistered = false;
    try {
      await ayeApi.checkPhoneNumber({
        body: {
          phoneNumber,
          countryCode: countryPhoneCode || '',
        },
      })
    } catch {
      alreadyRegistered = true
       setErrorMessage('Phone number is already registered.')
    } finally {
      setRedirectLoading(false)
    }

    if (alreadyRegistered) {
      return
    }

    try {
      const response: GeneratePayUrlResponse = await ayeApi.generatePayUrl({
        body: {
          phoneNumber: `${phoneNumber}`,
          countryCode: countryPhoneCode || '',
          face_index,
          pin,
          screen: 'register',
        },
      })
      sessionStorage.setItem('step', '3')
      sessionStorage.setItem('phoneComplete', 'true')
      if (response.success) window.open(response.data.payUrl, '_self')
      else if (!response.success) setErrorMessage(response.error.message)
    } catch (error: any) {
      console.log(error)
    } finally {
      setRedirectLoading(false)
    }
  }

  const idList = [
    { label: 'Phone Number', value: '5' },
    { label: 'Passport', value: '3' },
    { label: 'Malaysian Identity Card', value: '1' },
  ]

  const idTypeError = () => {
    return idNumber ? idNumber.length < 7 : false
  }

  const phoneNumberError = () => {
    return false
  }

  useEffect(() => {

    // const registrationStarted =
    //   sessionStorage.getItem('registration_started') === 'true'
    // const step = sessionStorage.getItem('step')
    // const pinComplete = sessionStorage.getItem('pinComplete') === 'true'

    // if (step !== '2' || !registrationStarted || !pinComplete) {
    //   navigate('/login')
    // }
  }, [])
  return (
    <>
      <div
        className="mt-2 flex flex-col items-center justify-center bg-white"
        style={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          minHeight: '100vh',
        }}>
        <div
          className="flex h-full w-full px-2 flex-col items-center justify-center"
          style={{
            minHeight: selectedPaymentMethod === 'CreditCard' ? 900 : 750,
          }}>
          <img src={logo} alt="Aye Logo" width={'7%'} className="mt-4" />
          <div className="md:w-[70%] px-8">
            <div className="flex justify-center">
              <PaymentMethodComponent
                onSelectedChange={(value) => setSelectedPaymentMethod(value)}
              />
            </div>

            <div>
              {selectedPaymentMethod === 'CreditCard' ? (
                <CreditDebitComponent
                  setCountryPhoneCode={setCountryPhoneCode}
                  setPhoneNumber={setPhoneNumber}
                  phoneNumberError={phoneNumberError}
                />
              ) : (
                <DuitnowComponent
                  setCountryPhoneCode={setCountryPhoneCode}
                  idTypeError={idTypeError}
                  handleChange={handleChange}
                  setIdNumber={setIdNumber}
                  idList={idList}
                  idType={idType}
                  setPhoneNumber={setPhoneNumber}
                  phoneNumberError={phoneNumberError}
                />
              )}
            </div>

            {errorMessage && (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  color: '#E94F4F',
                  marginTop: 8,
                }}>
                <p className="text-center">{errorMessage}</p>
              </div>
            )}

            <div className="mt-2 flex items-center">
              <Checkbox
                checked={checked}
                color="success"
                onChange={() => setChecked(true)}
              />
              <div>
                <p>I have read and agree to the </p>
                <button
                  onClick={() =>
                    window.open('https://aye-ai.org/user-tc/', 'blank')
                  }
                  className="underline">
                  terms and conditions
                </button>
              </div>
            </div>
            <div className="mt-5 flex justify-center">
              <Button
                variant="contained"
                style={{ width: '50%', height: 50 }}
                color="success"
                onClick={submit}
                disabled={loading}>
                {loading ? <CircularProgress size={24} /> : 'Submit'}
              </Button>
            </div>
          </div>
        </div>
      </div>

      <TermsAndConditions open={open} setOpen={setOpen} />
      <LoadingModal open={redirectLoading} />
    </>
  )
}

export default RegisterScreen
